import React, { useContext, FunctionComponent, ReactElement } from "react";
import styled, { ThemeContext } from "styled-components";
import Button from "../../../../common/Buttons/Button";
import Icon from "../../../../common/Icons/Icon";
import { SuccessProps } from "./types";

const StyledSuccess = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 540px;
  padding: 15px 0 48px;
`;

const StyledText = styled.div`
  margin-bottom: 8px;
`;

const StyledIcon = styled.div`
  margin-bottom: 20px;
`;

const Success: FunctionComponent<SuccessProps> = ({ onOk, text }): ReactElement => {
  const { MODAL: { SUCCESS_ICON } } = useContext(ThemeContext);

  return (
    <StyledSuccess>
      <StyledText>{text}</StyledText>
      <StyledIcon>
        <Icon name="okCircle" size={51} color={SUCCESS_ICON} />
      </StyledIcon>
      <Button label="Ok, that's all" theme="SUCCESS_SECONDARY" onClick={onOk} />
    </StyledSuccess>
  );
};

export default Success;
